import { useSelector, useDispatch } from 'react-redux';
import { TableRow } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { setGroupIdParams } from '@app/store/slices/groupIdSlice';
import { CounterIcon, Status } from '@shared/ui/parts';
import { useMemberInfoDialog } from '@utils/dialogs-hooks';
import { getTotalActiveHoldCards } from '@utils/helpers';
import { theme } from '@utils/libs/theme';
import { oneTeamColumns } from '@utils/tables/columns';
import { StatusCreatedAtCell } from '@widgets/tables/cells/common';
import {
  MemberActionCell,
  MemberActivityCell,
  MemberCell,
  MemberContactCell,
  MemberName,
  MemberTeamsAvatar,
} from '@widgets/tables/cells/members';
import {
  TeamCardLimitCell,
  TeamTxCardLimitCell,
} from '@widgets/tables/cells/teams';
import { CustomTable, CustomTableMobile } from '@widgets/tables/main';

export default function TeamsIdTable() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { openMemberInfoDialog } = useMemberInfoDialog();
  const {
    users,
    params,
    count_total,
    count_filtered,
    isLoading,
    isInitialized,
    search,
  } = useSelector((state) => state.group_id);

  const handleSetParams = (newParams) => {
    dispatch(setGroupIdParams(newParams));
  };

  return isMobile ? (
    <CustomTableMobile
      params={params}
      setParams={handleSetParams}
      totalCount={count_total || 0}
      filteredCount={count_filtered || 0}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      data={users}
    >
      {users?.map((row) => (
        <div
          onClick={() => openMemberInfoDialog(row)}
          key={row.id}
          className="tableMobile__list-item teamsMobile__item"
        >
          <MemberTeamsAvatar row={row} />
          <div className="teamsMobile__item-details">
            <MemberName row={row} />
            <div className="teamsMobile__item-counters">
              <CounterIcon
                icon="card-input"
                value={getTotalActiveHoldCards(row)}
                hasBg
              />
            </div>
          </div>
          <div className="teamsMobile__item-status align-start">
            <Status data={row} type="team" />
          </div>
        </div>
      ))}
    </CustomTableMobile>
  ) : (
    <CustomTable
      columns={oneTeamColumns}
      data={users}
      filteredCount={count_filtered || 0}
      totalCount={count_total || 0}
      params={params}
      setParams={handleSetParams}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
    >
      {users?.map((row) => (
        <TableRow tabIndex={-1} key={row.id}>
          <MemberCell row={row} />
          <StatusCreatedAtCell row={row} type="team" />
          <MemberContactCell row={row} />
          <TeamTxCardLimitCell row={row} />
          <TeamCardLimitCell row={row} />
          <MemberActivityCell />
          <MemberActionCell row={row} />
        </TableRow>
      ))}
    </CustomTable>
  );
}
